import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { getDashboardAssetTypesSummaryExport } from '@api/dashboardPO';

import { IExportFileDTO } from '@interfaces/platform/dto/platformDashboardDTO';

import { ESnackbarTypes } from '@enums/common';

import { DASHBOARD_ASSET_TYPES_SUMMARY_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export function useMutateDashboardAssetTypesSummaryExport() {
	const dispatch = useAppDispatch();

	const {
		mutate: exportDashboardAssetTypesSummary,
		isLoading: isLoadingDashboardAssetTypesSummaryExport,
	} = useMutation<IExportFileDTO>({
		mutationKey: [DASHBOARD_ASSET_TYPES_SUMMARY_EXPORT],
		mutationFn: getDashboardAssetTypesSummaryExport,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		exportDashboardAssetTypesSummary,
		isLoadingDashboardAssetTypesSummaryExport,
	};
}
